package com.evoapps.evoshift.domain.model

/** SH-123: tills the app can read takings from (docs/pos-import.md). */
enum class PosProvider { SUMUP }

/** How the last import of a connected till went. */
enum class PosSyncStatus {
    OK,
    /** The till refused the key (revoked or replaced): the owner connects again with a new one. */
    KEY_REJECTED,
    /** The till could not be read (it is retried on the next run). */
    FAILED
}

/** What one import did (functions/posImport.js `lastSyncSummary`). */
data class PosSyncSummary(
    val written: Int = 0,
    val keptManual: Int = 0,
    val closed: Int = 0,
    val unchanged: Int = 0,
    /** Days with sales whose month has no daily records yet (no plan for it). */
    val noRecord: Int = 0,
    val noSales: Int = 0,
    /** The first and last day read (ISO dates). */
    val from: String? = null,
    val to: String? = null
)

/**
 * A workplace's till connection (pos_integrations/{workplaceId}); the API key is never part of
 * it: only the functions read it, from Secret Manager. [vatRatePercent] takes the net takings out
 * of the till's gross payments.
 */
data class PosIntegration(
    val workplaceId: String,
    val provider: PosProvider,
    val merchantCode: String,
    val vatRatePercent: Double,
    val connectedAt: String? = null,
    val lastSyncAt: String? = null,
    val lastSyncStatus: PosSyncStatus? = null,
    val lastSync: PosSyncSummary? = null
)

/** Why a till could not be connected or read; null [reason]: a failure without one. */
enum class PosRefusal { KEY_INVALID, KEY_REJECTED, NO_MERCHANT, VAT_INVALID, NOT_CONNECTED, PLAN_ENDED }

class PosConnectionException(val reason: PosRefusal) : Exception("Till: $reason")
